import {isFeatureEnabled} from '@github-ui/feature-flags'
import {CreateIssueButton} from '@github-ui/issue-create/CreateIssueButton'
import {TriageAgentButton} from '@github-ui/issue-triage-agent/TriageAgentButton'
/* eslint-disable-next-line @github-ui/github-monorepo/no-use-app-payload --
   useAppPayload is deprecated. See
   https://thehub.github.com/epd/engineering/dev-practicals/frontend/react/data-router/migration/app-payload-deprecation/ */
import {useAppPayload} from '@github-ui/react-core/use-app-payload'
import {useFeatureFlag} from '@github-ui/react-core/use-feature-flag'
import {Link} from '@github-ui/react-router'
import {useNavigate} from '@github-ui/use-navigate'
import {useUser} from '@github-ui/use-user'
import {MilestoneIcon, TagIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'

import {BUTTON_LABELS} from '../../constants/buttons'
import type {AppPayload} from '../../types/app-payload'
import styles from './SearchBarActions.module.css'

type SearchBarActionsProps = {
  isOwnerEnterpriseManaged: boolean
  nameWithOwner: string | null
  isWritable: boolean | null
}

export function SearchBarActions({isOwnerEnterpriseManaged, nameWithOwner, isWritable}: SearchBarActionsProps) {
  const navigate = useNavigate()
  const {currentUser} = useUser()
  const {scoped_repository, current_user_settings} = useAppPayload<AppPayload>()

  /* eslint-disable-next-line @github-ui/github-monorepo/no-use-feature-flags --
     TODO: Migrate to isFeatureEnabled from @github-ui/feature-flags. See
     https://thehub.github.com/epd/engineering/dev-practicals/frontend/react/data-router/migration/app-payload-deprecation/ */
  const showTriageAgentButton = useFeatureFlag('issues_triage_agent_enrolled') && scoped_repository

  const isEmuUserInNonOwnedRepo = currentUser != null && !!currentUser?.is_emu && !isOwnerEnterpriseManaged

  const hideCreateButton = isWritable === false || isEmuUserInNonOwnedRepo

  const labelsPath = `/${nameWithOwner}/labels`
  const milestonesPath = `/${nameWithOwner}/milestones`

  return (
    <div className={`${styles.buttons} ${styles.gap8} d-flex flex-wrap`}>
      {isFeatureEnabled('issue_pinned_views') ? (
        <Button as={Link} to={labelsPath} leadingVisual={TagIcon}>
          Labels
        </Button>
      ) : (
        <Button as="a" href={labelsPath} leadingVisual={TagIcon}>
          Labels
        </Button>
      )}
      {isFeatureEnabled('issue_pinned_views') ? (
        <Button as={Link} to={milestonesPath} leadingVisual={MilestoneIcon}>
          Milestones
        </Button>
      ) : (
        <Button as="a" href={milestonesPath} leadingVisual={MilestoneIcon}>
          Milestones
        </Button>
      )}
      {showTriageAgentButton && (
        <TriageAgentButton repoOwner={scoped_repository.owner} repoName={scoped_repository.name} />
      )}
      {!hideCreateButton && (
        <CreateIssueButton
          label={BUTTON_LABELS.newIssue}
          navigate={navigate}
          optionConfig={{
            issueCreateArguments: {
              repository: scoped_repository
                ? {
                    owner: scoped_repository.owner,
                    name: scoped_repository.name,
                  }
                : undefined,
            },
            showRepositoryPicker: scoped_repository === null,
            emojiSkinTonePreference: current_user_settings?.preferred_emoji_skin_tone,
            showFullScreenButton: true,
            canBypassTemplateSelection: true,
            navigate,
          }}
        />
      )}
    </div>
  )
}
